import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  confirmThoughtsApiCrud,
  type ConfirmThoughtsRequest,
} from "@/generated/fastapi";

export async function confirmThoughts(
  accessToken: string | null | undefined,
  request: ConfirmThoughtsRequest,
) {
  const response = await confirmThoughtsApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to update thoughts (${response.status})`);
  }

  return response.data;
}
